import { render, staticRenderFns } from "./RecommendationModal.vue?vue&type=template&id=a2c3800a&scoped=true&"
import script from "./RecommendationModal.vue?vue&type=script&lang=js&"
export * from "./RecommendationModal.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationModal.vue?vue&type=style&index=0&id=a2c3800a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c3800a",
  null
  
)

export default component.exports